let th = {
    translations: {
        // Hero
        "badge-mgm": "แนะนำเพื่อน รับของรางวัล",
        "hero-title-line1": "แนะนำเพื่อน",
        "hero-title-line2": "รับบัตรของขวัญเซ็นทรัล",
        "hero-subtitle": "เมื่อสมาชิกที่คุณแนะนำซื้อคูปองสปริงเคิล 24 ใบ และเริ่มรับบริการจัดส่งน้ำดื่ม คุณจะได้รับบัตรของขวัญห้างเซ็นทรัลโดยอัตโนมัติ",

        // Gift cards
        "gift-title": "บัตรของขวัญมูลค่า",
        "gift-description1": "เมื่อแนะนำสมาชิกใหม่ 1 ท่าน ภายใน 1 เดือน",
        "gift-description2": "เมื่อแนะนำสมาชิกใหม่ 2 ท่าน ภายใน 1 เดือน",
        "gift-description3": "เมื่อแนะนำสมาชิกใหม่ 6 ท่าน ภายใน 6 เดือน",

        // Conditions
        "conditions-title": "เงื่อนไข",
        "bonus": "แนะนำสมาชิกใหม่ 6 ท่าน ภายใน 6 เดือน (ต่อเนื่องนับจากการจัดส่งครั้งแรก) รับเพิ่มอีก 3,000 บาท",
        "first-point": "สมาชิกใหม่ชำระค่ามัดจำถัง",
        "second-point": "สมาชิกใหม่ชำระค่าคูปองแลกรับน้ำดื่มสปริงเคิล 24 ใบ",
        "third-point": "สมาชิกใหม่รับน้ำดื่มสปริงเคิล และสั่งซื้อคูปองแลกรับน้ำดื่ม 24 ใบ ชุดที่ 2",
        "fourth-point": "สมาชิกใหม่รับน้ำดื่มอย่างต่อเนื่อง และสั่งซื้อคูปองแลกรับน้ำดื่มสปริงเคิลอีก 1 ชุด หลังจากได้รับการแนะนำ",
        "notes-title": "หมายเหตุ",
        "first-note": "คูปอง 12 ใบ/ชุด ไม่เข้าร่วมรายการ",
        "second-note": "มัดจำขั้นต่ำ 3 ถัง",
        "third-note": "ที่อยู่ของสมาชิกใหม่ต้องไม่ซ้ำกับที่อยู่ของสมาชิกปัจจุบัน",
        "fourth-note": "หลังจากแนะนำสมาชิกใหม่ สมาชิกปัจจุบันต้องซื้อคูปองเพื่อรับบริการน้ำดื่มอย่างต่อเนื่องอย่างน้อย 1 ชุด",
        "fifth-note": "ผู้ได้รับบัตรของขวัญมูลค่า 1,000 บาทขึ้นไป ต้องเสียภาษี ณ ที่จ่าย 5%",

        // Form
        "submit-referral-title": "ส่งข้อมูลการแนะนำ",
        "recommender-form-title": "สมาชิกผู้แนะนำ",
        "member-form-title": "สมาชิกใหม่",
        "membership-no": "รหัสสมาชิก",
        "name": "ชื่อ/บริษัท",
        "address": "ที่อยู่",
        "phone": "เบอร์โทรศัพท์",
        "email": "อีเมล",
        "confirm-button": "ยืนยันการสมัครสมาชิก",

        // Thank you
        "success": "สำเร็จ",
        "success-title": "บริษัทได้รับข้อมูลจากท่านแล้ว",
        "success-subtitle": "ท่านจะได้รับการติดต่อกลับเพื่อยืนยันภายใน 7 วันทำการ",
        "back-to-catalog-button": "กลับไปหน้ารายการสินค้า",
    }
};

export default th;
